{
  "version": 1,
  "asset_id": "94897922-4b57-4067-bfa1-fbe6023dcbc7",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/94897922-4b57-4067-bfa1-fbe6023dcbc7/rentals-hewescraft-1600.jpg",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/94897922-4b57-4067-bfa1-fbe6023dcbc7/rentals-hewescraft-1600.jpg",
  "original_filename": "rentals-hewescraft-1600.jpg",
  "size": 351767,
  "content_type": "image/jpeg",
  "created_at": "2026-07-03T03:49:18Z"
}
